import { render, staticRenderFns } from "./resumo-dados.vue?vue&type=template&id=9ad51d84&scoped=true"
import script from "./resumo-dados.vue?vue&type=script&lang=js"
export * from "./resumo-dados.vue?vue&type=script&lang=js"
import style0 from "./resumo-dados.vue?vue&type=style&index=0&id=9ad51d84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad51d84",
  null
  
)

export default component.exports